export enum STATE_SHORT {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  SA = 'SA',
  TAS = 'TAS',
  VIC = 'VIC',
  WA = 'WA',
  QLD = 'QLD',
}

/**
 * Long state names
 * Can be accessed like: STATE_LONG[STATE_SHORT.ACT]
 */
export enum STATE_LONG {
  ACT = 'Australian Capital Territory',
  NSW = 'New South Wales',
  NT = 'Northern Territory',
  SA = 'South Australia',
  TAS = 'Tasmania',
  VIC = 'Victoria',
  WA = 'Western Australia',
  QLD = 'Queensland',
}
